export default {
      id: "returns-menu-usage",
      viewBox: "0 0 31.297 31.297",
      url: "/dist/svg/" + "sprite.svg#returns-menu-usage",
      toString: function () {
        return this.url;
      }
    }